import styled from 'styled-components'

export const IconContainer = styled.div`
  display: flex;
`
